import { Link } from "react-router-dom";
import { MapPin, ShieldCheck } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer className="bg-[#0B1510] text-slate-400 relative grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3 relative z-10">
        <div>
          <p className="font-display text-2xl font-bold text-white tracking-tight">Başkent Sitesi</p>
          <p className="mt-3 text-sm leading-relaxed max-w-xs">91 müstakil villadan oluşan, doğayla iç içe huzurlu yaşam alanı.</p>
        </div>
        <div className="text-sm">
          <p className="eyebrow text-[#D8F3DC] mb-3">Adres</p>
          <p className="flex gap-2"><MapPin size={16} className="shrink-0 mt-0.5" /> Büğdüz Mah. 156. Sok. No:17, Akyurt / Ankara</p>
        </div>
        <div className="text-sm md:text-right">
          <p className="eyebrow text-[#D8F3DC] mb-3">Yönetim</p>
          <Link to="/yonetim/giris" className="inline-flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-admin-login-link">
            <ShieldCheck size={16} /> Yönetici Girişi
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs relative z-10">© 2026 Başkent Sitesi Yönetimi</div>
    </footer>
  );
}
